import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import urbanHeatPoster from '../../../Assets/Images/Training/Training Compendium/urban_Heat_Island.jpg'

const Using_Building_Envelopes_as_Heat_Sink_to_Manage_Urban_Heat_Island = () => {

    return (
        <div className="mt-5">
            <h4>Using Building Envelopes as Heat Sink to Manage Urban Heat Island (UHI) In Developing Countries</h4>

            <div className="card mt-5">
                <img
                    src={urbanHeatPoster}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p><strong>Aim:</strong> The aim of this Compendium is to evaluate context-specific building  envelope strategies for their potential as heat sinks to mitigate the Urban Heat  Island effect in developing countries, by quantifying their UHI reduction  capabilities, assessing their feasibility and implementation for short term and long term mitigation strategies.</p>
                <p>This compendium addresses the Urban Heat Island (UHI) effect in developing  countries by proposing the use of building envelopes as heat sinks, offering a  context-specific guide for the Global South. It details tactical actions like  implementing cool roofs with local materials and green infrastructure.  Operationally, it focuses on practical application using affordable materials,  adapting local construction techniques, and ensuring community engagement. The  guide also outlines strategic systemic changes, including updated building codes,  financial incentives, and collaborative capacity building. By integrating these short  and long-term strategies across all levels, the compendium serves as a vital guide  for stakeholders to transform buildings into tools for creating cooler, more  sustainable urban environments.</p>
            </div>

        </div>
    );
};

export default Using_Building_Envelopes_as_Heat_Sink_to_Manage_Urban_Heat_Island;
